module.exports = __webpack_public_path__ + "static/media/weblogo.08ee9254.png";